export const PROPERTY_SPACE_PERSON_en = {
  translation: {
    actions: {
      createApartment: 'Create space',
      bulk: {
        deleteResidentsMessage: 'Are you sure you want to delete {{count}} selected persons?',
        deleteApartmentsMessage: 'Are you sure you want to delete {{count}} selected spaces?',
        deleteCondominiumsMessage: 'Are you sure you want to delete {{count}} selected properties?',
        editResidentsTitle: 'Edit persons',
        editApartmentsTitle: 'Edit spaces',
        editCondominiumsTitle: 'Edit properties',
        selectResidentApartment: 'Select space',
      },
    },
    keys: {
      condominium: 'Property',
      apartment: 'Space',
      handoverInstructions: 'Key handover instructions',
      handoverInstructionsPlaceholder: 'Write instructions for key handover and return',
      resident: 'Person',
    },
    key: {
      handoverAddFromDirectory: 'By property or space',
      handoverDirectoryHint:
        'Pick a property or space, or type at least two characters to search (stamp, address, property).',
      handoverDirectoryNoQuery: 'Select a property or space, or type at least 2 characters to search.',
      handoverAddResident: 'Create new person',
    },
    common: {
      space: 'Space',
    },
    apartment: {
      apartments: 'Spaces',
      deleteTitle: 'Delete space',
      deleteMessage: 'Are you sure you want to delete this space? This action cannot be undone.',
      apartment: 'Space',
    },
    apartments: {
      title: 'Spaces',
      searchPlaceholder: 'Search spaces...',
      editApartment: 'Edit space',
      apartment: 'Space',
      defaultTitle: 'Space',
      notFoundDescription: 'The requested space was not found, or you do not have permission to view it.',
      residents: 'Persons',
      deleteResidentTitle: 'Delete person',
      deleteResidentMessage: 'Are you sure you want to delete the person',
      createNew: 'Create new space',
      createMultiple: 'Create multiple spaces',
      multipleLabel: 'Create multiple spaces',
      multipleDescription: 'Enable to create multiple spaces at once using a number range',
      condominium: 'Property',
      selectCondominium: 'Select property',
      createMultipleDescription: 'Create multiple spaces at once using a number range',
      addResident: 'Add person',
      condominiumRequired: 'Property is required',
      residentsCount: 'Persons',
      showEmptyOnly: 'Only spaces without people',
    },
    validation: {
      condominiumRequired: 'Property is required',
      apartmentRequired: 'Space is required',
    },
    residents: {
      title: 'Persons',
      searchPlaceholder: 'Search persons...',
      editResident: 'Edit person',
      createResident: 'Create new person',
      apartment: 'Space',
      apartmentRequired: 'Space is required',
      selectApartment: 'Select space',
      noResidentsFound: 'No persons found',
      noResidentsWithoutApartment: 'All persons already have a space',
    },
    wizard: {
      title: 'Quick property setup',
      subtitle: 'Create property, spaces, persons and keys at once',
      steps: {
        condominium: 'Property',
        apartments: 'Spaces',
        residents: 'Persons',
      },
      stepDescriptions: {
        condominium: 'Create a new property by filling in the basic information',
        apartments: 'Add spaces to the property individually or in bulk',
        residents: 'Add persons and link them to spaces',
      },
      actions: {
        addApartment: 'Add space',
        addResident: 'Add person',
      },
      info: {
        noApartmentsForResidents: 'Add spaces first before adding persons.',
      },
      apartmentsList: 'Spaces',
      residentsList: 'Persons',
    },
    general: {
      noApartments: 'No spaces',
      noResidents: 'No persons',
      emptyFilterShort: 'Empty',
      showBulkDelete: 'Show bulk delete in tables',
      showBulkDeleteDescription:
        'Enable selecting and deleting multiple items in spaces, persons, properties, and keys tables.',
    },
    condominiums: {
      apartmentKeyType: "Property's key type",
    },
    condominium: {
      header: 'Properties',
      condominiums: 'Properties',
      condominiumDetails: 'Property details',
      name: 'Property',
      superIntendent: 'Super Intendent',
      selectSuperIntendent: 'Select super intendent...',
      create: 'Create property',
      edit: 'Edit property',
      update: 'Update property',
      deleteTitle: 'Delete property',
      deleteMessage: 'Are you sure you want to delete the property',
      apartments: 'Spaces',
      searchPlaceholder: 'Search properties...',
      nocondominiumsForSearch: 'No properties found for "{{searchTerm}}"',
      nocondominiumsYet: 'No properties.',
      selectSuperintendent: 'Select super intendent...',
      apartmentKeyType: "Property's key type",
      selectCondominium: 'Select a condominium',
      transfer: {
        toSubCompany: 'Transfer to sub company',
        transferredTooltip: 'Transferred to sub company',
        transferredTo: 'Transferred to {{name}}',
        subCompanyCanEdit: 'Sub company can edit transferred data',
        revokeTransfer: 'Revoke transfer',
        changeEditAccess: 'Change edit access',
        selectSubCompany: 'Select sub company',
        confirmTransfer: 'Confirm transfer',
        transferSuccess: 'Transfer completed',
        revokeConfirm:
          'Are you sure you want to revoke the transfer? The sub company will lose access to the property.',
        transferredAt: 'Transferred at',
        back: 'Back',
        next: 'Next',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Transferred properties',
      personalDataPurge: {
        targetsHint: 'People are selected by default. Add properties, spaces, and keys when needed.',
        peopleGroupHint: 'Persons, landlords, and rental applicants.',
        propertyGroupHint: 'Properties, spaces, and keys go to the same 7-day trash.',
        targetTypes: {
          resident: 'Persons',
          condominium: 'Properties',
          apartment: 'Spaces',
        },
        fields: {
          condominiumId: 'Property',
          apartmentId: 'Space',
        },
        columns: {
          condominium: 'Property',
        },
      },
    },
    messages: {
      selectResident: 'Select person',
      apartmentCreated: 'Space created successfully',
      apartmentsCreated: 'Spaces created successfully',
      apartmentUpdated: 'Space updated successfully',
      apartmentDeleted: 'Space deleted successfully',
      apartmentsDeletedBulk: '{{count}} spaces deleted successfully',
      saveApartmentSuccess: 'Space saved successfully',
      condominiumCreated: 'Property created successfully',
      condominiumUpdated: 'Property updated successfully',
      condominiumDeleted: 'Property deleted successfully',
      condominiumsDeletedBulk: '{{count}} properties deleted successfully',
      residentCreated: 'Person created successfully',
      residentUpdated: 'Person updated successfully',
      residentDeleted: 'Person deleted successfully',
      residentsDeletedBulk: '{{count}} persons deleted successfully',
      saveResidentSuccess: 'Person saved successfully',
      apartmentCreateFailed: 'Space creation failed',
      apartmentsCreateFailed: 'Spaces creation failed',
      apartmentUpdateFailed: 'Space update failed',
      apartmentDeleteFailed: 'Space deletion failed',
      saveApartmentFailed: 'Saving space failed',
      condominiumCreateFailed: 'Property creation failed',
      condominiumUpdateFailed: 'Property update failed',
      condominiumDeleteFailed: 'Property deletion failed',
      residentCreateFailed: 'Person creation failed',
      residentUpdateFailed: 'Person update failed',
      residentDeleteFailed: 'Person deletion failed',
      saveResidentFailed: 'Saving person failed',
    },
    resident: {
      residentDetails: 'Person details',
      notFound: 'Person not found',
      apartment: 'Space',
      noApartment: 'No space',
      deleteTitle: 'Delete person',
      deleteMessage: 'Are you sure you want to delete the person "{{name}}"? This action cannot be undone.',
    },
    dashboard: {
      myManagedProperties: 'Properties I manage',
      noProperties: 'No properties to display',
    },
    properties: {
      tabProperties: 'Properties',
      tabApartments: 'Spaces',
      tabResidents: 'Persons',
      createProperty: 'Create property',
      createApartment: 'Create space',
      createResident: 'Create person',
      searchApartments: 'Search spaces...',
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Shown during key handover and return. You can define instructions at company, billing account, property and space levels; the more specific level overrides the broader one.',
      },
      wizard: {
        superintendent:
          'The super intendent is the person responsible for the daily management and maintenance of the property.',
      },
      condominium: {
        businessId: 'Finnish Business ID in the format 1234567-8. Optional, but recommended for official properties.',
      },
      apartments: {
        multiple:
          'Create multiple spaces with consecutive numbers (e.g. A1, A2, A3). All spaces share the same main address.',
      },
      settings: {
        showMyProperties: 'Show properties where you are listed as super intendent or have special privileges.',
        showBulkDelete: 'Enable selecting and deleting multiple items in tables (spaces, persons, properties, keys).',
      },
    },
    import: {
      condominiums: 'Properties',
      apartments: 'Spaces',
      residents: 'Persons',
      condominiumsInstructions: 'Import properties',
      condominiumsInstructionsDescription: 'Fill at least the name and address information. Other fields are optional.',
      condominiumsFieldSuperIntendent: 'Super Intendent: Full name (e.g. "John Doe")',
      apartmentsInstructions: 'Import spaces',
      apartmentsInstructionsDescription: 'Address and property are required fields.',
      apartmentsFieldCondominium: 'Property: Name of an existing property',
      keysFieldCondominium: 'Property: Name of an existing property (for general keys only)',
      residentsInstructions: 'Import persons',
      residentsInstructionsDescription: 'Name, email, and space are required.',
      residentsFieldApartment: 'Space: Full address in the form "Street, Postal Code City"',
      errors: {
        superintendentNotFound: 'Not found',
        condominiumNotFound: 'Not found',
        condominiumRequiredForGeneral: 'Property is required for general key types',
        condominiumNotAllowedForNonGeneral: 'Property cannot be assigned to non-general key types',
      },
    },
    invitations: {
      condominium: 'Property',
      apartment: 'Space',
      extraPermissions: 'Additional permissions',
      canDoUpkeeps: 'Can do inspections',
      canRespondToServiceRequests: 'Can respond to service requests',
      canSeeResidents: 'Can see persons',
      canAccessAllApartments: 'Access all spaces in property',
      canAccessAllKeys: 'Access all keys',
      canAccessAllServiceRequests: 'Access all service requests',
    },
    contractor: {
      property: 'Property',
      apartment: 'Space',
      selectProperty: 'Select property',
      selectApartment: 'Select space',
      keyAccessFilterCondominiumPlaceholder: 'All properties',
      keyAccessFilterApartmentPlaceholder: 'All spaces',
    },
    contractorDashboard: {
      properties: 'Properties',
      apartments: 'Spaces',
    },
    documentBank: {
      searchPlaceholder: 'Search properties, spaces, or billing accounts…',
      sections: {
        condominiums: 'Properties',
      },
    },
    events: {
      entityType: {
        resident: 'Person',
        apartment: 'Space',
        condominium: 'Property',
        key: 'Key',
        landlord: 'Landlord',
      },
    },
    reports: {
      totalApartments: 'Spaces',
      totalResidents: 'Persons',
      totalCondominiums: 'Properties',
    },
    billingAccount: {
      addApartments: 'Add spaces',
      noUnassignedApartments: 'No unassigned spaces.',
      noLinkedApartments: 'No spaces linked to this billing account yet.',
      linkPropertiesForRelatedLists:
        'Link at least one property or space to this billing account to browse related data.',
    },
    billing: {
      auditCondominium: 'Properties',
      auditApartment: 'Spaces',
      auditResident: 'People',
      auditKey: 'Keys',
      colCondominium: 'Property',
      colApartment: 'Space',
    },
    landlordPortal: {
      allApartmentsOption: 'All spaces',
    },
    residentNotifications: {
      tabTitle: 'Person announcements',
      createTitle: 'New person announcement',
      editTitle: 'Edit person announcement',
      deleteTitle: 'Delete announcement',
      scope: {
        wholeCondominium: 'Whole property',
        apartmentCount: '{{count}} spaces',
      },
      field: {
        wholeCondominium: 'Whole property',
        wholeCondominiumHelp: 'Visible to all spaces under this property in the person and landlord portals.',
        apartments: 'Selected spaces',
      },
      validation: {
        apartments: 'Select at least one space, or choose the whole property.',
      },
      portalTitle: 'Person announcements',
    },
    maintenance: {
      needsAssessment: {
        selectCondominium: 'Select property to filter the list.',
      },
    },
    upkeep: {
      allApartments: 'All spaces',
      filterApartments: 'Filter spaces',
      filterApartmentsPlaceholder: 'Enter name, address or space',
      createApartmentInspections: 'Create space inspections',
      selectCondominiums: 'Select properties',
      multiBatchAllApartmentsHelp: 'Creates rows for all spaces in each selected property.',
      filterCondominiums: 'Filter properties',
      filterCondominiumsPlaceholder: 'Enter property name or address',
      sendResidentNotification: 'Send person notice',
      sendResidentNotificationHelp:
        'The same notice is sent to persons of the selected properties (and shown in portals).',
      batchCreatedWithNotification: 'Upkeep created ({{count}} rows) and person notice sent',
      multiBatchCreatedWithNotification:
        'Created {{batches}} upkeep packages ({{count}} rows) and {{notices}} person notices',
      wizardStepLocationHelp:
        'Select the property and space if needed. If no space is selected, you can choose multiple spaces at once.',
      wizardStepLocationHelpEquipment:
        'Select the property and space if needed. If no space is selected, choose spaces with devices in the next step.',
      locationProperty: 'Property',
      locationSpace: 'Space',
      trackedAssetsHelpSingleApartment: 'Inspect devices for this space. One task, one report.',
      trackedAssetsHelpSingleApartmentNamed: 'Inspect devices for space {{apartment}}. One task, one report.',
      trackedAssetsScopeApartment: 'Space: {{apartment}}',
      trackedAssetsHelpMultiApartment:
        'Select spaces and their devices. One inspection is created per space with the same template.',
      trackedAssetsEmpty: 'No devices for the selected property',
      trackedAssetsEmptyApartment: 'No devices in space {{apartment}}',
      trackedAssetsEmptySelectedApartment: 'No devices for the selected space',
      trackedAssetApartmentFilter: 'Filter by space',
      trackedAssetApartmentFilterAll: 'All spaces',
      targetApartments: 'Spaces',
      targetApartmentsHelp: 'Select spaces to create upkeep for (one report per space).',
      targetApartmentsEquipmentHelp: 'Select spaces whose devices will be inspected. Each space gets its own report.',
      targetApartmentsBatchHelp:
        'Optional: select multiple spaces to create the same inspection or maintenance for each.',
      targetApartmentsBatchCountHelp: 'This creates {{count}} separate tasks, one per space.',
      targetApartmentsSelected: '{{count}} spaces selected',
      targetApartmentsRequired: 'Select at least one space',
      selectApartmentsBeforeDevices: 'Select spaces first, then their devices.',
      noApartmentsForProperty: 'This property has no spaces',
      batchCreated: 'Created {{count}} upkeep tasks (one per space)',
    },
    trackedAssets: {
      columnCondominium: 'Property',
      filterCondominium: 'Filter property',
      selectCondominium: 'Select property',
      apartment: 'Space',
      selectApartment: 'Select space',
      mapEmptyHint: 'Link the asset to a property or space that has an address.',
      bulkCreateUpkeepSameCondo: 'Select assets from the same property only.',
    },
    rentalBrokerage: {
      apartment: 'Space',
      resident: 'Person',
      landlord: 'Landlord',
      createApartment: 'Create space',
      createResidentFromApplicant: 'Create person',
      createResident: 'Create person',
      createLandlord: 'Create landlord',
      residentFromApplicant: 'Created / linked from applicant',
      partyApplicantNeedsResident: 'Applicant: {{name}} — select or create a person',
      applyTitle: 'Apply for the space',
      targetKind: {
        apartment: 'Space',
      },
    },
    residentPortal: {
      filesSectionTitle: 'Space and property files',
      apartment: 'Space',
      selectApartment: 'Select space...',
    },
  },
};
